import Radio from './radio';
import Group from './group';
import Button from './radioButton';
Radio.Button = Button;
Radio.Group = Group;
export { Button, Group };
export default Radio;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_antd@4.1.3@antd/es/radio/index.js
// module id = 42
// module chunks = 0